package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("__typename")
    val typename: String?=null,
    @SerialName("updateProduct")
    val updateProduct: ProductSets?=null,
    @SerialName("getProduct")
    val getProduct: ProductSets?=null,
)